import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {HomePage} from '../home/home.page';
import {MenuPage} from '../menu/menu.page';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {Location} from '@angular/common';

@Component({
	selector: 'app-accessibility-statement',
	templateUrl: './accessibility-statement.page.html',
	styleUrls: ['./accessibility-statement.page.scss'],
    standalone: false,
})
export class BarrierefreiheitPage {
	static url = 'barrierefreiheit';

	constructor(
		private repository: RepositoryService,
		private router: Router,
		private location: Location
	) {}

	static async navigate(router: Router) {
		await router.navigateByUrl(BarrierefreiheitPage.url);
	}

	goBack() {
		if (this.location) {
			this.location.back();
			return;
		}
		if (this.repository._order === null) {
			HomePage.navigate(this.router);
		} else {
			MenuPage.navigate(this.router);
		}
	}
}
